<template>
    <b-container>
        <b-row>
            <b-col cols="6" lg="3">
                <DateInput v-model="fromDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <DateInput v-model="toDate"></DateInput>
            </b-col>
            <b-col cols="6" lg="3">
                <b-form-select v-model="selectedEvent" :options="eventOptions"></b-form-select>
            </b-col>
            <b-col cols="6" lg="3">
                <b-button-group block class="w-100">
                    <b-button @click="getData">{{$t('admin_report.show_report')}}</b-button>
                    <b-button variant="light" @click="exportData"><font-awesome-icon icon="file-export"></font-awesome-icon></b-button>
                </b-button-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <LineChart :chart-data="chartData" height="200px"></LineChart>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import {DateTime} from 'luxon'
    import _ from 'lodash';
    import LineChart from "./LineChart";
    import {library} from '@fortawesome/fontawesome-svg-core'
    import {faFileExport} from '@fortawesome/free-solid-svg-icons'
    import DateInput from "../DateInput";

    library.add(faFileExport);

    export default {
        name: 'EventAttendanceReport',
        components: {DateInput, LineChart},
        data() {
            return {
                fromDate: DateTime.local().startOf('year').toISO(),
                toDate: DateTime.local().endOf('year').toISO(),
                selectedEvent: null,
                events: [],
                rawData: null,
            }
        },
        computed: {
            eventOptions() {
                return _.concat(
                    this.events.map(function (e) {
                        return {value: e, text: e.name};
                    }));
            },
            chartData() {
                if (!this.rawData) {
                    return {}
                }

                let datasets = [];

                datasets.push({
                    borderColor: 'rgba(0, 0, 0, 1)',
                    label: this.$t('admin_report.participant_user'),
                    fill: false,
                    data: this.rawData['participants'].map(function(d) {
                        return d.value;
                    })
                });

                datasets.push({
                    borderColor: 'rgba(100, 0, 0, 1)',
                    label: this.$t('admin_report.attendance_user'),
                    fill: false,
                    data: this.rawData['attendance'].map(function(d) {
                        return d.value;
                    })
                });

                let labels = this.rawData['participants'].map(function (d) {
                    return d.label;
                });

                return {
                    labels: labels,
                    datasets: datasets,
                }
            },
        },
        mounted() {
            this.getEvents();
        },
        watch: {
            fromDate(newValue) {
                if (this.fromDate && this.toDate) {
                    this.getEvents();
                }
            },
            toDate(newValue) {
                if (this.fromDate && this.toDate) {
                    this.getEvents();
                }
            },
        },
        methods: {
            getEvents() {
                this.$callAPI('hkiarace/admin/event/', {
                    from: DateTime.fromISO(this.fromDate).toSeconds(),
                    to: DateTime.fromISO(this.toDate).toSeconds(),
                }, function (response) {
                    this.events = response.body.events;
                })
            },
            getData() {
                this.$callAPI('hkiarace/admin/report/', {
                    report_type: 'EVENT_ATTENDANCE',
                    params: {
                        event_id: this.selectedEvent.id,
                    },
                }, function (response) {
                    this.rawData = response.body.datasets;
                })
            },
            exportData() {
                this.$downloadFile('hkiarace/admin/report/export/', {
                        report_type: 'EVENT_ATTENDANCE',
                        params: {
                            event_id: this.selectedEvent.id,
                        },
                    },
                    'export.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
            },
        },
    }
</script>

<style>

</style>
